import { makeApi } from "@zodios/core";
import { z } from "zod";

// shared
export const GenerateImagesModel = z.enum(["dall-e-3", "gpt-image-1"]);

export type GenerateImagesModel = z.infer<typeof GenerateImagesModel>;

// dall-e-3
export const Dalle3SizeOptions = z.enum(["1024x1024", "1792x1024", "1024x1792"]);

export type Dalle3SizeOptions = z.infer<typeof Dalle3SizeOptions>;

export const Dalle3QualityOptions = z.enum(["hd", "standard"]);

export type Dalle3QualityOptions = z.infer<typeof Dalle3QualityOptions>;

export const Dalle3StyleOptions = z.enum(["vivid", "natural"]);

export type Dalle3StyleOptions = z.infer<typeof Dalle3StyleOptions>;

export const Dalle3GenerateImages = z.object({
  model: GenerateImagesModel.extract(["dall-e-3"]),
  prompt: z.string().describe("The prompt to be used"),
  size: Dalle3SizeOptions.describe("The size of the images"),
  quality: Dalle3QualityOptions.describe("The quality of the images"),
  style: Dalle3StyleOptions.describe("The style of the images"),
});

export type Dalle3GenerateImages = z.infer<typeof Dalle3GenerateImages>;

// gpt-image-1
export const GptImage1SizeOptions = z.enum(["1024x1024", "1536x1024", "1024x1536"]);

export type GptImage1SizeOptions = z.infer<typeof GptImage1SizeOptions>;

export const GptImage1QualityOptions = z.enum(["high", "medium", "low"]);

export type GptImage1QualityOptions = z.infer<typeof GptImage1QualityOptions>;

export const GptImage1GenerateImages = z.object({
  model: GenerateImagesModel.extract(["gpt-image-1"]),
  prompt: z.string().describe("The prompt to be used"),
  size: GptImage1SizeOptions.describe("The size of the images"),
  quality: GptImage1QualityOptions.describe("The quality of the images"),
  outputFormat: z.enum(["png", "webp", "jpeg"]).describe("The output format of the images"),
  n: z.string().describe("The number of generations to create"),
});

export type GptImage1GenerateImages = z.infer<typeof GptImage1GenerateImages>;

export const GenerateImages = z.discriminatedUnion("model", [Dalle3GenerateImages, GptImage1GenerateImages]);

export type GenerateImages = z.infer<typeof GenerateImages>;

export const GeneratedImages = z.object({
  generatedImages: z.array(z.string()).describe("The generated images"),
});

export type GeneratedImages = z.infer<typeof GeneratedImages>;

export const generatedImagesApi = makeApi([
  {
    method: "get",
    path: "/copilot/generated-images",
    alias: "getGeneratedImages",
    parameters: [
      {
        type: "Query",
        name: "input",
        schema: GenerateImages,
      },
    ],
    response: GeneratedImages,
    errors: [
      { status: 400, schema: z.string() },
      { status: 401, schema: z.string() },
    ],
  },
]);
